const translations = {
  en: {
    nav: {
      home: "Home",
      teachers: "Our Teachers",
      courses: "Courses",
      teacherGallery: "Teacher Gallery",
      performanceInfo: "Performance Info",
      performances: "Performance Videos",
      contact: "Contact",
      language: "中文",
    },
    hero: {
      title: "Day Music Studio",
      subtitle:
        "Melbourne's Premier Chinese Traditional Music School",
      description:
        "Professional Erhu, Pipa & Zhongruan lessons taught by world-class musicians from the Central Conservatory of Music, Beijing.",
      cta: "Explore Our Courses",
    },
    courses: {
      sectionTitle: "Music Courses",
      sectionSubtitle:
        "Private and group lessons for all ages and levels — from curious beginners to advanced performers preparing for exams and concerts.",
      items: [
        {
          instrument: "Erhu",
          chineseName: "二胡",
          description:
            "Often called the 'Chinese violin', the erhu is one of the most expressive bowed string instruments. Learn erhu in Melbourne with Dongyan Ma, former Associate Principal of the China National Traditional Orchestra.",
          levels: "Beginner to Advanced",
          icon: "erhu",
        },
        {
          instrument: "Pipa",
          chineseName: "琵琶",
          description:
            "The pipa is a four-stringed plucked instrument with over 2,000 years of history. Study pipa in Melbourne with Yang Ying, University of Melbourne lecturer and Vienna Golden Hall performer.",
          levels: "Beginner to Concert Level",
          icon: "pipa",
        },
        {
          instrument: "Zhongruan",
          chineseName: "中阮",
          description:
            "The zhongruan offers a warm, resonant tone and is a cornerstone of the Chinese orchestra. Ideal for students who love rich, mellow string sounds.",
          levels: "Beginner to Advanced",
          icon: "zhongruan",
        },
      ],
      features: [
        "One-on-one private lessons tailored to your goals",
        "AMEB & ABRSM exam preparation",
        "Performance opportunities with local ensembles",
        "Bilingual instruction in English and Chinese",
      ],
    },
    teachers: {
      sectionTitle: "Our Music Teachers",
      sectionSubtitle:
        "World-class Chinese music educators based in Melbourne, bringing decades of professional performance and teaching experience.",
      dongMa: {
        name: "Dongyan Ma",
        title: "Eminent Huqin Performer & Educator",
        instrument: "Erhu / Huqin Family",
        bio: [
          "Dong is a distinguished figure in the realm of Chinese traditional music, specializing in the huqin family of instruments. He received his professional training at the Central Conservatory of Music in Beijing, where he laid a solid foundation for his artistic career.",
          "His professional journey includes serving as Associate Principal of the China National Traditional Orchestra and as a founding member of the Singapore Chinese Orchestra. Currently, he shares his expertise as an instructor of Chinese traditional music at the Melbourne Conservatorium of Music and several other educational institutions in Australia.",
          "Dong has established himself as a cultural ambassador through collaborations with major symphony orchestras and ensembles worldwide. His notable performances include appearances with the Melbourne Symphony Orchestra and a memorable participation in the 2025 Second World War Memorial Concert with the Canberra Symphony Orchestra. He also collaborated with the Flanders String Quartet in the acclaimed premiere of Jingjun Yu's arrangement of Bach's Goldberg Variations for erhu and string quartet, demonstrating his exceptional ability to bridge musical traditions.",
          "In June 2025, he returned to his alma mater, the Central Conservatory of Music in Beijing, where he presented a highly successful solo recital that received critical acclaim.",
        ],
        highlights: [
          "Central Conservatory of Music, Beijing",
          "Associate Principal, China National Traditional Orchestra",
          "Founding Member, Singapore Chinese Orchestra",
          "Instructor, Melbourne Conservatorium of Music",
          "Soloist with Melbourne Symphony Orchestra & Canberra Symphony Orchestra",
        ],
      },
      yangYing: {
        name: "Yang Ying",
        title: "Distinguished Pipa Performer & Educator",
        instrument: "Pipa / Zhongruan",
        bio: [
          "Yang Ying is a distinguished pipa performer with a rich background in music education. She earned her Bachelor of Arts degree in Music from the Department of Chinese Music at the Central Conservatory of Music, where she specialised in pipa performance under the mentorship of Professor Lin Shicheng, a renowned pipa virtuoso and educator. During her studies, she also pursued elective courses in zhongruan, achieving exceptional proficiency in both instruments.",
          "Following graduation, she joined the China National Traditional Orchestra as a liuqin performer. Her tenure included numerous significant recording projects, spanning Japan, Singapore, Taiwan, Hong Kong, and Macau. In 1998, she performed at the prestigious \"Golden Hall\" in Austria, for the inaugural New Year Concert to widespread acclaim and enthusiasm.",
          "Subsequently, she relocated to Singapore, where she served as an instructor at various institutions including primary schools, secondary schools, junior colleges, and universities.",
          "In 2021, she was featured as a soloist with the Melbourne Symphony Orchestra performing \"Spring Flower Moon Night,\" receiving high praise and admiration from critics and audiences alike. Currently, she is appointed as a lecturer in plucked string instruments at the University of Melbourne.",
        ],
        highlights: [
          "Central Conservatory of Music, Beijing",
          "Former Performer, China National Traditional Orchestra",
          "Soloist with Melbourne Symphony Orchestra",
          "Performed at Vienna Golden Hall, 1998",
          "Lecturer, University of Melbourne",
        ],
      },
    },
    performanceInfo: {
      sectionTitle: "Performance Information",
      viewPoster: "View poster",
      posterAlt: "Baaz Avaz: On the Silk Road — May 25, 6–7PM, Gasworks Open Studio",
    },
    performances: {
      sectionTitle: "Performance Videos",
      videos: [
        {
          title: "\"Crescent Moon Over Five Watches\" — Dongyan Ma, Banhu Recital at Central Conservatory of Music",
          embedUrl: "https://www.youtube.com/embed/Hx95ok3q3G4",
          description: "",
        },
        {
          title: "Pipa with Symphony Orchestra — Moonlit Night on Spring River",
          embedUrl: "https://www.youtube.com/embed/1V951SEUqCQ",
          description:
            "Yang Ying with Melbourne Symphony Orchestra, 2021 Chinese New Year Concert.",
        },
        {
          title: "Moonlit Night on Spring River — Pipa & Piano",
          embedUrl: "https://www.youtube.com/embed/Ga12MAuslIs",
          description: "Pipa: Yang Ying — Piano: Dongyan Ma",
        },
        {
          title: "Dongyan Ma & Flinders Quartet — Bach's Goldberg Variations, No. 30 \"Quodlibet\", Erhu & String Quartet",
          embedUrl: "https://www.youtube.com/embed/XfQirWNg4h4",
          description: "Arranged by Jingjun Yu. Bach used German and Italian folk song themes in the original. Yu ingeniously weaves Shanxi folk melodies into the harmonic texture, achieving a seamless fusion of Chinese and Western music.",
        },
      ],
    },
    teacherGallery: {
      sectionTitle: "Teacher Gallery",
      viewPhoto: "View photo",
    },
    contact: {
      sectionTitle: "Start Your Musical Journey",
      description:
        "Whether you are a beginner picking up a Chinese instrument for the first time, or an advanced student preparing for exams and concerts, we welcome you to learn with Melbourne's finest Chinese music teachers.",
      email: "Email",
      phone: "Phone",
      wechat: "WeChat",
      location: "Location",
      locationValue: "Melbourne, Victoria, Australia",
      youtube: "Day Music Studio Channel",
      cta: "Enquire About Lessons",
    },
    footer: {
      copyright: "Day Music Studio. All rights reserved.",
      tagline:
        "Professional Erhu, Pipa & Zhongruan lessons in Melbourne, Australia.",
      visitorsTitle: "Visitor statistics",
      visitorsLabel: "Total visits",
      mapTitle: "Where our visitors are from",
      mapPlaceholder:
        "Map widget not configured yet. Register a free widget at clustrmaps.com and paste the ID into VisitorStats.js.",
    },
  },
  zh: {
    nav: {
      home: "首页",
      teachers: "师资介绍",
      courses: "课程设置",
      teacherGallery: "教师风采",
      performanceInfo: "演出信息",
      performances: "演出视频",
      contact: "联系我们",
      language: "EN",
    },
    hero: {
      title: "Day Music工作室",
      subtitle: "墨尔本专业二胡·琵琶·民乐教学",
      description:
        "中央音乐学院毕业名师亲授，墨尔本大学及墨尔本音乐学院在职讲师，专业民族器乐一对一教学。",
      cta: "了解课程",
    },
    courses: {
      sectionTitle: "课程设置",
      sectionSubtitle:
        "面向所有年龄段和水平的学生，从零基础入门到专业考级、演出备赛，提供一对一及小组授课。",
      items: [
        {
          instrument: "二胡",
          chineseName: "二胡",
          description:
            "二胡被誉为\u201C中国小提琴\u201D，是最富表现力的民族拉弦乐器。由原中央民族乐团副首席马东岩老师亲自授课，教学经验丰富，因材施教。",
          levels: "零基础至演奏级",
          icon: "erhu",
        },
        {
          instrument: "琵琶",
          chineseName: "琵琶",
          description:
            "琵琶有两千多年历史，音色清脆明亮，表现力极强。由墨尔本大学讲师、曾在维也纳金色大厅演出的杨缨老师亲自教授。",
          levels: "零基础至演奏级",
          icon: "pipa",
        },
        {
          instrument: "中阮",
          chineseName: "中阮",
          description:
            "中阮音色温暖浑厚，是民族管弦乐团的重要声部。适合喜爱柔美深沉弦乐音色的学生学习。",
          levels: "零基础至进阶",
          icon: "zhongruan",
        },
      ],
      features: [
        "一对一私教课程，量身定制教学计划",
        "AMEB及各类音乐考级辅导",
        "参与本地民乐合奏及演出机会",
        "中英双语教学，沟通无障碍",
      ],
    },
    teachers: {
      sectionTitle: "师资介绍",
      sectionSubtitle:
        "两位老师均毕业于中央音乐学院，拥有数十年专业演出与教学经验，现任墨尔本各大音乐院校讲师。",
      dongMa: {
        name: "馬東岩",
        title: "馬東岩 — 著名胡琴演奏家、教育家",
        instrument: "二胡 / 胡琴",
        bio: [
          "马东岩是中国传统音乐领域的杰出人物，专精于胡琴家族乐器的演奏。他毕业于中央音乐学院，在那里奠定了坚实的艺术基础。",
          "他的职业生涯包括担任中国中央民族乐团副首席，以及新加坡华乐团的创始成员。目前，他在墨尔本音乐学院及澳大利亚多所教育机构担任中国传统音乐讲师，分享他的专业知识与演奏技艺。",
          "马东岩通过与世界各地主要交响乐团和乐团的合作，成为了一位文化使者。他的重要演出包括与墨尔本交响乐团的合作演出，以及2025年与堪培拉交响乐团在二战纪念音乐会上的精彩表演。他还与弗兰德斯弦乐四重奏合作，首演了于京君编曲的巴赫《哥德堡变奏曲》二胡与弦乐四重奏版本，展现了他卓越的跨文化音乐融合能力。",
          "2025年6月，他重返母校中央音乐学院，举办了一场备受好评的独奏音乐会。",
        ],
        highlights: [
          "中央音乐学院（北京）",
          "中央民族乐团副首席",
          "新加坡华乐团创始成员",
          "墨尔本音乐学院讲师",
          "墨尔本交响乐团及堪培拉交响乐团独奏家",
        ],
      },
      yangYing: {
        name: "楊纓",
        title: "楊纓 — 著名琵琶演奏家、教育家",
        instrument: "琵琶 / 中阮",
        bio: [
          "杨缨是一位杰出的琵琶演奏家，拥有丰富的音乐教育背景。她毕业于中央音乐学院中国音乐系，获得音乐学士学位，师从著名琵琶大师、教育家林石城教授，专攻琵琶演奏。在校期间，她还选修了中阮课程，在两种乐器上均达到了卓越的演奏水准。",
          "毕业后，她加入中央民族乐团担任柳琴演奏员。任职期间参与了大量重要录音项目，足迹遍及日本、新加坡、台湾、香港和澳门。1998年，她在奥地利维也纳金色大厅参加了首场新年音乐会的演出，获得了广泛的赞誉与热烈反响。",
          "此后，她移居新加坡，在当地多所教育机构担任音乐教师，包括小学、中学、初级学院和大学。",
          "2021年，她作为独奏家与墨尔本交响乐团合作演出了《春江花月夜》，获得了评论家和观众的高度赞扬。目前，她受聘于墨尔本大学，担任弹拨乐器讲师。",
        ],
        highlights: [
          "中央音乐学院（北京）",
          "原中央民族乐团演奏员",
          "墨尔本交响乐团独奏家",
          "1998年维也纳金色大厅演出",
          "墨尔本大学讲师",
        ],
      },
    },
    performanceInfo: {
      sectionTitle: "演出信息",
      viewPoster: "查看海报",
      posterAlt: "Baaz Avaz：丝绸之路 — 5月25日 6–7PM，Gasworks 开放工作室",
    },
    performances: {
      sectionTitle: "演出视频",
      videos: [
        {
          title: "《月牙五更》马东岩 中央音乐学院 板胡专场音乐会",
          embedUrl: "https://www.youtube.com/embed/Hx95ok3q3G4",
          description: "",
        },
        {
          title: "琵琶与交响乐团 —《春江花月夜》",
          embedUrl: "https://www.youtube.com/embed/1V951SEUqCQ",
          description:
            "杨缨与墨尔本交响乐团，2021中国新年音乐会。",
        },
        {
          title: "春江花月夜 — 琵琶与钢琴",
          embedUrl: "https://www.youtube.com/embed/Ga12MAuslIs",
          description: "琵琶：杨缨 — 钢琴：马东岩",
        },
        {
          title: "马东岩与Flinders Quartet 二胡与弦乐四重奏 — 巴赫《哥德堡变奏曲》之三十\u201C集腋曲\u201D",
          embedUrl: "https://www.youtube.com/embed/XfQirWNg4h4",
          description: "编曲：于京君。巴赫在原曲中采用了包括德国民歌和意大利民歌素材为主题，于老师大胆巧妙地将中国山西民歌曲调在不改变和声织体情况下融入其中，完美融合。",
        },
      ],
    },
    teacherGallery: {
      sectionTitle: "教师风采",
      viewPhoto: "查看照片",
    },
    contact: {
      sectionTitle: "开启您的音乐之旅",
      description:
        "无论您是零基础的民乐爱好者，还是准备考级、演出的进阶学生，欢迎联系我们，与墨尔本最专业的民乐老师一起学习二胡、琵琶、中阮。",
      email: "电子邮件",
      phone: "电话",
      wechat: "微信",
      location: "地点",
      locationValue: "澳大利亚·墨尔本",
      youtube: "Day Music工作室频道",
      cta: "咨询课程",
    },
    footer: {
      copyright: "Day Music工作室 版权所有",
      tagline: "墨尔本专业二胡、琵琶、中阮民乐教学",
      visitorsTitle: "访问统计",
      visitorsLabel: "累计访问",
      mapTitle: "访客来自世界各地",
      mapPlaceholder:
        "尚未配置地图小部件。请到 clustrmaps.com 免费注册一个，把 widget ID 粘贴到 VisitorStats.js 中。",
    },
  },
};

export default translations;
